<div class="routing__map">
    <div class="routing__map--standard-map" [ngClass]="{'map-visible':showConfirmAddresses}">
        <app-standard-map [options]="mapOptions"></app-standard-map>
    </div>
    <app-routing-form class="routing__map--form" [form]="form" *ngIf="!showConfirmAddresses"></app-routing-form>
    <app-routing-confirm-address class="routing__map--form" *ngIf="showConfirmAddresses"
        [ngClass]="{'map-visible':showConfirmAddresses}" [form]="form" (refreshMap)="refreshMap($event)">
    </app-routing-confirm-address>
</div>